"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgumentNullError = void 0;
/**
 * An error thrown if an argument passed to a function or constructor is null or empty.
 */
class ArgumentNullError extends Error {
    /**
     * Initializes a new instance of the @see ArgumentNullError class.
     * @param message Error message.
     * @param parameter Name of the parameter that was null or empty.
     */
    constructor(message, parameter) {
        super(message);
        this.parameter = parameter;
    }
}
exports.ArgumentNullError = ArgumentNullError;
//# sourceMappingURL=argumentNullError.js.map